import { useRef, useEffect, useState } from 'react';
import { Search, LineChart, CheckCircle2, Activity, Send, ClipboardList } from 'lucide-react';
import { SectionHeader } from '../common';

const STEPS = [
  { icon: Search, label: 'Discover', desc: 'AI scans the market.' },
  { icon: LineChart, label: 'Analyze', desc: 'Understand market structure.' },
  { icon: CheckCircle2, label: 'Validate', desc: 'Backtest the strategy.' },
  { icon: Activity, label: 'Monitor', desc: 'Track market signals.' },
  { icon: Send, label: 'Execute', desc: 'Send trades to connected accounts.' },
  { icon: ClipboardList, label: 'Review', desc: 'Analyze results in Trade Journal.' },
];

export default function EndToEndWorkflow() {
  const ref = useRef(null);
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    const onScroll = () => {
      const el = ref.current; if (!el) return;
      const rect = el.getBoundingClientRect(); const vh = window.innerHeight;
      const total = rect.height + vh * 0.6;
      setProgress(Math.max(0, Math.min(1, (vh - rect.top) / total)));
    };
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <section className="section">
      <div className="container-x" ref={ref}>
        <div className="reveal"><SectionHeader center eyebrow="End-to-End Workflow" title="One disciplined loop, start to finish." /></div>
        <div className="relative mt-16 max-w-[900px] mx-auto">
          <div className="hidden md:block absolute top-0 bottom-0 left-[27px] w-[2px]" style={{ background: 'var(--border-strong)' }}>
            <div style={{ height: `${progress * 100}%`, background: 'var(--gold-grad)', width: '100%', transition: 'height .15s linear', boxShadow: '0 0 12px rgba(214,179,106,.5)' }} />
          </div>
          <div className="flex flex-col gap-6">
            {STEPS.map((s, i) => {
              const active = progress * STEPS.length >= i;
              return (
                <div key={s.label} className="flex items-start gap-5 reveal" style={{ transitionDelay: `${i * 50}ms` }}>
                  <div className="w-14 h-14 rounded-full flex items-center justify-center shrink-0 relative z-10 transition-all duration-500" style={{ background: active ? 'var(--gold-soft)' : 'var(--surface)', border: `1px solid ${active ? 'var(--gold-border)' : 'var(--border)'}` }}>
                    <s.icon size={22} style={{ color: active ? 'var(--gold-2)' : 'var(--muted-2)', transition: 'color .5s' }} />
                  </div>
                  <div className="pt-2">
                    <h3 className="font-display text-[18px] font-bold text-white">{s.label}</h3>
                    <p className="text-[14.5px] text-[var(--muted)] mt-0.5">{s.desc}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
